import { MappingDataView } from "../../../../shared/MappingDataView";
import { TabHeader } from "../../../../shared/TabHeader";
import { Button } from "primereact/button";
import { scopeStringId } from "../lib";

export const Company = ({ toastRef }) => {
  return (
    <>
      <TabHeader
        title="Firma"
        infoButtonConfigObj={{
          tooltip:
            "Na zakładce możesz skonfigurować synchronizację pól firm z obu systemów oraz ją uruchomić",
        }}
      >
        <Button icon="pi pi-arrow-right-arrow-left" label="Synchronizuj" />
      </TabHeader>
      <MappingDataView scopeStringId={scopeStringId} toastRef={toastRef} />
    </>
  );
};
